

exports.__esModule = true;
exports.$OneTouchUpsellRoute = undefined;

var _squid = require('squid');

require('./directive');

var $OneTouchUpsellRoute = exports.$OneTouchUpsellRoute = _squid.$ComponentRoute.extend('OneTouchUpsellRoute', {
    name: 'oneTouchUpsell',
    directive: 'xo-onetouch-upsell',
    trackingData: {
        fptiState: 'onetouch-upsell',
        buzname: {
            'fullpage': {
                'pagename': '%::onetouch-upsell',
                'pagename2': '%::onetouch-upsell:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    query: ['oneTouchFlowName'],
    children: []
});
angular.value("$OneTouchUpsellRoute", $OneTouchUpsellRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-login-components/src/onetouch-interstitial/route.js
// module id = ../node_modules/xo-login-components/src/onetouch-interstitial/route.js
// module chunks = 0